// @flow
export const kgToPounds = (kg: number): number => Math.round(+kg * 2.268);

export const poundsToKg = (pounds: number): number => pounds / 2.268;

export const roundKg = (kg: number): number => Math.round(kg);
